// extracted by mini-css-extract-plugin
module.exports = {"text":"SubscriberOrdersDetails_text__2Pqvx","tooltip":"SubscriberOrdersDetails_tooltip__2i-wl"};